module.exports = new __parcel__URL__("logo_region_bretagne.caddeb8e.png").toString();